
import { mapGetters } from 'vuex'

export default {
  name: 'MarketContainer',
  props: {
    markets: {
      type: Array,
      required: true
    },
    content: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      currentMarketId: 'frontend/currentMarketId'
    }),
    blocks () {
      // Use this method to filter out if the block should display
      // depending on market, if it should use a default one or not etc
      return this.content.filter(() => {
        return !this.markets.length || this.markets.includes(this.currentMarketId.toString())
      }) || []
    }
  },
}
